import { CircularProgress, Typography, Grid } from "@material-ui/core";
import SanitizedGrid from "components/SanitizedGrid";
import { useState, useEffect } from "react";
import {
  CreateProps,
  useNotify,
  useMutation,
  Toolbar,
  Button,
  Create,
  SimpleForm,
  ReferenceInput,
  AutocompleteInput,
  required,
  TextInput,
  maxLength,
  useRedirect,
  useRefresh,
} from "react-admin";
import { GetParam, SchoolIdSelected } from "utils/tools";
import SaveIcon from "@material-ui/icons/Save";
import { useFormState } from "react-final-form";

const CustomerReceiptsCreate = (props: CreateProps) => {
  const param = GetParam();
  const cantChange = param.get("cantChange");

  const CustomerReceiptsToolbar = (props: any) => {
    const [isDisabled, setIsDisabled] = useState<boolean>(false);
    const { values } = useFormState();
    const notify = useNotify();
    const redirect = useRedirect();
    const refresh = useRefresh();

    useEffect(() => {
      if (values.parentId && values.amount && values.description) {
        setIsDisabled(false);
      } else {
        setIsDisabled(true);
      }
    }, [values]);

    const [handleSaveBankTransfer, { loading }] = useMutation(
      {
        type: "create",
        resource: "customerReceipts",
        payload: {
          data: {
            parentId: values.parentId,
            schoolId: Number(SchoolIdSelected()),
            description: values.description,
            amount: Number(Math.round(values.amount * 100).toFixed(2)),
          },
        },
      },
      {
        onSuccess: ({ data }) => {
          notify(`Successfully Generate.`, "info");
          redirect(`/customerReceipts`);
          refresh();
        },
        onFailure: (error) =>
          notify(`Failed Generate, error: ${error.message}`, "warning"),
      }
    );

    return (
      <Toolbar {...props}>
        <Button
          onClick={handleSaveBankTransfer}
          disabled={isDisabled || props.invalid}
          label={loading ? "Generating..." : "Generate"}
        >
          {loading ? (
            <CircularProgress size={18} thickness={2} />
          ) : (
            <SaveIcon />
          )}
        </Button>
      </Toolbar>
    );
  };

  return (
    <>
      <Typography variant="h4">Create Receipts</Typography>
      <Create title={"Create Receipts"} {...props}>
        <SimpleForm toolbar={<CustomerReceiptsToolbar />}>
          <SanitizedGrid container spacing={2}>
            <Grid item xs={12}>
              <Typography variant="h6">General Info</Typography>
            </Grid>

            <Grid item xs={8}>
              <ReferenceInput
                label="Parent"
                source="parentId"
                reference="parents"
                filter={{
                  SchoolId: Number(SchoolIdSelected()),
                  IsHaveMainStudent: true,
                }}
                filterToQuery={(searchText: any) => {
                  if (searchText !== "") return { search: searchText };
                }}
                validate={required()}
                disabled={cantChange === "true" ? true : false}
              >
                <AutocompleteInput
                  optionText={(choice: any) =>
                    `${choice.id} - ${choice.firstName} ${choice.lastName}`
                  }
                />
              </ReferenceInput>
            </Grid>

            <Grid item xs={12}></Grid>

            <Grid item xs={12}>
              <Typography variant="h6">Receipt Detail</Typography>
            </Grid>

            <Grid item xs={8}>
              <TextInput
                label="Amount ($)"
                source="amount"
                placeholder="Please Input amount"
                type="number"
              />
            </Grid>

            <Grid item xs={8}>
              <TextInput
                multiline={true}
                label="Description"
                source="description"
                inputProps={{ maxLength: 90 }}
                placeholder="Description is only up to 90 characters"
                validate={[required(), maxLength(90)]}
              />
            </Grid>
          </SanitizedGrid>
        </SimpleForm>
      </Create>
    </>
  );
};

export default CustomerReceiptsCreate;
